import '../styles/Projects.css'
import { motion } from 'framer-motion'
import { slideIn } from '../utils/variants';
function Projects() {
    return (
        <div className="projects-container">
            <div className="projects-header">
                <h1>Projects</h1>
                <a href="#contact-section">CONTACT ME</a>
            </div>
            <div className="projects-collection">
            <motion.div
                variants={slideIn("right", 0.1)}
                initial="hidden"
                whileInView={"show"}
                    viewport={{ once: false, amount: 0.1 }}
                    className="project-card">
                    
                    <div className="project-1 img-overlay ">

                        <div className="project-links">
                            <a href="https://astrokojo.github.io/Netflix-clone/">View Live</a>
                            <a href="https://github.com/Astrokojo/Netflix-clone">Github</a>
                        </div>
                    </div>
                    <div className="project-details">
                        <h2>Netflix Clone</h2>
                        <p>HTML, CSS, Javascript</p>
                    </div>
                </motion.div>
            <motion.div
                variants={slideIn("left", 0.1)}
                initial="hidden"
                whileInView={"show"}
                    viewport={{ once: false, amount: 0.1 }}
                    className="project-card">
                    
                    <div className="project-2 img-overlay">

                        <div className="project-links">
                            <a href="/">View Live</a>
                            <a href="/">Github</a>
                        </div>
                    </div>
                    <div className="project-details">
                        <h2>Portfolio Site</h2>
                        <p>ReactJS, CSS</p>
                    </div>
                </motion.div>
            {/* <motion.div
                variants={slideIn("right", 0.1)}
                initial="hidden"
                whileInView={"show"}
                    viewport={{ once: false, amount: 0.1 }}
                    className="project-card">
                    
                    <div className="img-overlay">

                        <div className="project-links">
                            <a href="/">View Live</a>
                            <a href="/">Github</a>
                        </div>
                    </div>
                    <div className="project-details">
                        <h2>Project Name</h2>
                        <p>Languages</p>
                    </div>
                </motion.div>
            <motion.div
                variants={slideIn("left", 0.1)}
                initial="hidden"
                whileInView={"show"}
                    viewport={{ once: false, amount: 0.1 }}
                    className="project-card">
                    
                    <div className="img-overlay">

                        <div className="project-links">
                            <a href="/">View Live</a>
                            <a href="/">Github</a>
                        </div>
                    </div>
                    <div className="project-details">
                        <h2>Project Name</h2>
                        <p>Languages</p>
                    </div>
                </motion.div> */}
            </div>
        </div>
    )
}

export default Projects;